import { ColorEnum } from '@enum/style/color.enum';

import { ButtonStyleType } from './button.style-type';

export const ButtonDarkTheme: ButtonStyleType = {
  colorPrimary: ColorEnum.Teal100,
  colorPrimaryHover: ColorEnum.AdditionalSeaside75,
  colorPrimaryActive: ColorEnum.Teal150,
  colorLinkHover: ColorEnum.AdditionalSeaside75,
  colorLink: ColorEnum.Teal100,
  colorLinkActive: ColorEnum.Teal150,
  colorBgContainerDisabled: ColorEnum.Teal30,
  colorTextDisabled: ColorEnum.Black30,
  colorBackText: ColorEnum.Black100,
};
